<template>
  <div>
    <v-dialog
      v-model="dialog"
      persistent
      fullscreen
      dark
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar>
          <v-toolbar-title>
            Scan Barcode
          </v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn depressed rounded text @click="closeScanner">
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </v-toolbar>

        <div
          id="bar-code-reader"
          style="width:100%; height: 100%;"
        ></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'

export default {
  name: 'BaseBarcodeReader',
  props: {
    isValidResult: {
      type: Function,
      default: decodedText => /^[a-zA-Z0-9-]+$/.test(decodedText),
    },
    invalidResultMessage: {
      type: String,
      default:
        'ข้อมูลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง หรือพิมพ์ในช่องกรอกข้อมูล',
    },
  },
  mounted() {},
  data() {
    return {
      dialog: false,
      html5QrCode: null,
      index: 0,
    }
  },
  computed: {
    isHtml5Barcode() {
      return !!this.html5Barcode || false
    },
  },
  methods: {
    openScanner(event) {
      this.dialog = true
      this.index = event

      setTimeout(() => {
        this.startScanner()
      }, 1000)
    },
    closeDialog() {
      this.dialog = false
      this.index = 0
    },
    closeScanner() {
      this.closeDialog()

      // Ensure to cleanup and stop the scanner when the component is destroyed
      if (this.isHtml5Barcode) {
        this.html5Barcode.stop().catch(() => {
          //   Unable to stop scanning
          alert('เกิดข้อผิดพลาดในการหยุดการสแกน')
        })
      }
    },

    async startScanner() {
      // Create instance of the scanner
      this.html5Barcode = new Html5Qrcode('bar-code-reader')
      const config = {
        fps: 10,
        qrbox: { width: 320, height: 320 },
      }

      if (this.isHtml5Barcode) {
        try {
          const cameras = await Html5Qrcode.getCameras()
          if (cameras && cameras.length > 0) {
            // Start scanning
            this.html5Barcode.start(
              { facingMode: { exact: 'environment' } },
              config,
              // eslint-disable-next-line no-unused-vars
              (decodedText, decodedResult) => {
                this.html5Barcode
                  .stop()
                  .then(() => {
                    this.closeDialog()

                    if (!this.isValidResult(decodedText)) {
                      this.$toast.error(this.invalidResultMessage)
                      return
                    }

                    this.$emit('result', decodedText, this.index)
                  })
                  .catch(() => {
                    // Failed to stop the scanner
                    this.closeDialog()
                    alert('เกิดข้อผิดพลาดในการหยุดการสแกน')
                  })
              },
            )
          } else {
            this.closeDialog()
            // No cameras found. Please ensure your device has a camera and camera access is allowed
            alert(
              'ไม่พบกล้อง โปรดตรวจสอบว่าอุปกรณ์ของคุณมีกล้องและอนุญาตให้เข้าถึงกล้อง',
            )
          }
        } catch {
          this.closeDialog()
          //   Failed to start the scanner. Please ensure camera access is allowed.
          alert(
            'ไม่สามารถเริ่มสแกนได้ โปรดตรวจสอบสิทธิ์การเข้าถึงกล้อง',
          )
        }
      } else {
        // Failed to start the scanner. Please ensure camera access is allowed.
        alert(
          'ไม่สามารถเริ่มสแกนได้ โปรดตรวจสอบสิทธิ์การเข้าถึงกล้อง',
        )
      }
    },
  },
  beforeDestroy() {
    // Ensure to cleanup and stop the scanner when the component is destroyed
    if (this.isHtml5Barcode) {
      this.html5Barcode.stop().catch(() => {
        // Unable to stop scanning
        alert('เกิดข้อผิดพลาดในการหยุดการสแกน')
      })
    }
  },
}
</script>

<style lang="stylus" scoped>
#bar-code-reader {
  width: 100%;
  height: 100%;

  max-width: 100dvw;
  max-height: 100dvh;
}
</style>
